import { render, staticRenderFns } from "./val.vue?vue&type=template&id=88c7cbca&scoped=true"
import script from "./val.vue?vue&type=script&lang=js"
export * from "./val.vue?vue&type=script&lang=js"
import style0 from "./val.vue?vue&type=style&index=0&id=88c7cbca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88c7cbca",
  null
  
)

export default component.exports